export default class DateTimeLocalStr extends Date {
    override toString() {
        if (this.isValid()) return this.toLocaleString();
        return '';
    }
    override toJSON(key?: any) {
        if (this.isValid()) return this.toISOString();
        return null as unknown as string;
    }
}